<h2 mat-dialog-title>{{ "inspectionReportAddDialog.title" | translate }}</h2>

<mat-dialog-content fxLayout="row" fxLayoutAlign="center start">
  <div class="form-container" fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="10px">
    <!--template-->

    <div *ngIf="!isLoading && !templatesMaster.length" fxFlex="100%" class="template-warning">
      <mat-icon color="warn">warning</mat-icon>
      <span class="warning-message">{{ "inspectionReportAddDialog.noReportTemplate" | translate }}</span>
      <p>{{ "inspectionReportAddDialog.inspectionTemplateName" | translate }} "{{ data.subjectModelName }}"</p>

      <button mat-raised-button color="primary" (click)="openReportTemplate()">
        {{ "inspectionReportAddDialog.reportTemplateBuilder" | translate }}
      </button>
    </div>

    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="40px">
      <mat-form-field fxFlex>
        <mat-label class="top-label">{{ "inspectionReportAddDialog.reportTemplatePlaceholder" | translate }}</mat-label>
        <mat-select
          aria-label="reportTemplate"
          hideSingleSelectionIndicator
          [formControl]="reportTemplateControl"
          (selectionChange)="loadTemplateId()"
          required
        >
          <mat-option *ngFor="let template of templatesMaster" [value]="template.id">
            <span [matTooltip]="template.name" matTooltipPosition="above" matTooltipClass="tooltip-overflow">
              {{ template.name }}
            </span>
          </mat-option>
        </mat-select>
        <mat-error *ngIf="reportTemplateControl.invalid && reportTemplateControl.hasError('required')">
          {{ "inspectionReportAddDialog.reportTemplateRequired" | translate }}
        </mat-error>
      </mat-form-field>
    </div>
    <!--title-->
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <div class="title-div" fxFlex>
        <mat-form-field fxFlex>
          <mat-label class="top-label">{{ "inspectionReportAddDialog.reportNamePlaceholder" | translate }}</mat-label>
          <input matInput maxlength="100" [formControl]="reportTitleControl" required />
          <mat-hint align="end">{{ reportTitleControl.value?.length || 0 }}/100</mat-hint>
          <mat-error *ngIf="reportTitleControl.invalid && reportTitleControl.hasError('required')">
            {{ "inspectionReportAddDialog.reportNameRequired" | translate }}
          </mat-error>
          <mat-error *ngIf="reportTitleControl.invalid && reportTitleControl.hasError('maxlength')">
            {{ "inspectionReportAddDialog.reportNameMaxLengthRequired" | translate: { reportTitleMaxLength: reportTitleMaxLength } }}
          </mat-error>
          <mat-error *ngIf="reportTitleControl.hasError('pattern') && !reportTitleControl.hasError('required')">
            {{ "inspectionReportAddDialog.reportNameValidRequired" | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions fxLayoutAlign="end center">
  <button mat-button mat-dialog-close color="primary">{{ "inspectionReportAddDialog.cancel" | translate }}</button>
  <button mat-raised-button [disabled]="reportTitleControl.invalid || reportTemplateControl.invalid || isProcess" color="primary" (click)="save()">
    {{ "inspectionReportAddDialog.save" | translate }}
  </button>
</mat-dialog-actions>
